import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';


export const updateCountryFunc = createAsyncThunk(
    "updateCountry",
    async ({ id, data }, thunkAPI) => {
        try {
            const response = await api.put(`dashboard/countries/${id}`, data);
            return response.data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }

    }
)

const updateCountrySlicer = createSlice({
    name: "updateCountry",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(updateCountryFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        });
        builder.addCase(updateCountryFunc.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.apiErrors = action.payload?.errors || {};
        });
        builder.addCase(updateCountryFunc.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.successMessage = action.payload?.message || "";
        });
    }
});

export default updateCountrySlicer.reducer;